import React from 'react';

import { Alert } from '@mui/material';

import FontAwesomeIcon from './FontAwesomeIcon';
import { classNames } from './utils';

import styles from './Alert.module.css';

type IAlert = {
  txt: React.ReactNode; // string | JSX (like <span>)
  large?: boolean;
};

export function InfoAlert({ txt, large = false }: IAlert) {
  return (
    <Alert
      variant="filled"
      severity="info"
      className={classNames(styles.alert, large && styles.alertLarge)}
      icon={<FontAwesomeIcon name="circle-info" type="regular" />}
    >
      {txt}
    </Alert>
  );
}

export function SuccessAlert({ txt }: IAlert) {
  return (
    <Alert
      variant="filled"
      severity="success"
      className={classNames(styles.alert, styles.alertSuccess)}
    >
      {txt}
    </Alert>
  );
}
